import React, { useEffect } from "react";
import { Button } from "react-bootstrap";
import {
  useAcumuladorCantidad,
  useAcumuladorTotal,
} from "./../../../../Shared/Hooks/Custom.hooks";
import "./Total.component.scss";

const TotalComponent = ({
  productos = [],
  codigo = "",
  anularCotizacion = () => {},
  confirmarCotizacion = () => {},
}) => {
  const [cantidadAcumulado, setCantidad] = useAcumuladorCantidad(productos);
  const [totalAcumulado, setTotal] = useAcumuladorTotal(productos);

  const handleClickAnular = () => {
    anularCotizacion();
  };

  const handleClickConfirmar = () => {
    confirmarCotizacion();
  };

  useEffect(() => {
    setCantidad(productos);
    setTotal(productos);
  }, [productos]);

  return (
    <div className="Total">
      <div className="Total__Contenedor">
        <h3 className="Total__Contenedor--Titulo">Resumen</h3>
        <h5 className="Total__Contenedor--Nro">
          <span>Nro</span>
          <span>{codigo}</span>
        </h5>
        <h5 className="Total__Contenedor--Cantidad">
          <span>Productos</span>
          <span>{cantidadAcumulado}</span>
        </h5>
        <h5 className="Total__Contenedor--Total">
          <span>Total</span>
          <span>{totalAcumulado}</span>
        </h5>
        <div className="Total__Contenedor--Acciones">
          {productos.length > 0 ? (
            <>
              <Button variant="link" onClick={handleClickAnular}>
                Anular
              </Button>
              <Button variant="primary" onClick={handleClickConfirmar}>
                Confirmar
              </Button>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default TotalComponent;
